import { Button, Space, Table, Tag, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../common/PageTitle';
import { useGetAdminCourseListQuery } from '../../../features/courses/coursesApi';

const { Text } = Typography;

const formatDate = (date) => {
    if (!date) {
        return '-';
    }
    return new Intl.DateTimeFormat('pl-PL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(new Date(date));
};

const AdminCoursesPage = () => {
    const { t } = useTranslation();
    const { data: courses, isLoading } = useGetAdminCourseListQuery(
        'admin-course-catalog'
    );

    const columns = [
        {
            key: 'title',
            title: t('admin.courses.list.title'),
            render: (data) => (
                <Space direction="vertical" size={0}>
                    <Link to={`/app/courses/${data.id}`}>
                        <Text strong>{data.title}</Text>
                    </Link>
                </Space>
            ),
        },
        {
            key: 'author',
            title: t('admin.courses.list.author'),
            render: (data) => {
                if (!data?.author) {
                    return <Text type="secondary">-</Text>;
                }
                return (
                    <Space direction="vertical" size={0}>
                        <Text>{data.author.name}</Text>
                        <Text type="secondary">{data.author.email}</Text>
                    </Space>
                );
            },
        },
        {
            key: 'lessons_count',
            title: t('admin.courses.list.lessons'),
            align: 'center' as const,
            render: (data) => <Tag>{data?.lessons_count ?? 0}</Tag>,
        },
        {
            key: 'enrolled_count',
            title: t('admin.courses.list.enrolled'),
            align: 'center' as const,
            render: (data) => (
                <Tag color="blue">{data?.enrolled_count ?? 0}</Tag>
            ),
        },
        {
            key: 'created_at',
            title: t('admin.courses.list.created'),
            render: (data) => formatDate(data?.created_at),
        },
        {
            key: 'actions',
            title: '',
            align: 'right' as const,
            render: (data) => (
                <Link to={`/app/courses/${data.id}`}>
                    <Button size="small">{t('admin.courses.preview')}</Button>
                </Link>
            ),
        },
    ];

    return (
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <PageTitle title={t('admin.courses.header') as String} />
            <Table
                columns={columns}
                dataSource={courses}
                loading={isLoading}
                locale={{ emptyText: t('admin.courses.list.empty') }}
                rowKey={'id'}
                pagination={{ pageSize: 20 }}
            />
        </Space>
    );
};

export default AdminCoursesPage;
